export const LOCALSTORAGE_KEY_TOKEN = 'ccadmin.token';
export const LOCALSTORAGE_KEY_NAME = 'ccadmin.name';
export const LOCALSTORAGE_KEY_EXPIRY = 'ccadmin.expiry';
export const LOCALSTORAGE_KEY_ADMIN_TOKEN = 'ccadmin.adminToken';